<template>
  <div class="post">
    <h1 v-html="posting.title" />
    <!-- {{ $route.params.lang }}    {{ $route.params.slug }} -->
    <router-view class="posting-body" />
    <router-link to="/" tag="a" class="back">&laquo; Back</router-link>
  </div>
</template>
<script>
import Overview from "@/data/overview";

export default {
  name: "Posts",
  data() {
    return {
      posting: {}
    };
  },
  mounted: function() {
    this.posting = Overview.find(el => el.slug == this.$route.name);

    let instaScript = document.createElement("script");
    instaScript.setAttribute("src", "//www.instagram.com/embed.js");
    document.head.appendChild(instaScript);

    let twitterScript = document.createElement("script");
    twitterScript.setAttribute(
      "src",
      "https://platform.twitter.com/widgets.js"
    );
    document.head.appendChild(twitterScript);
  }
};
</script>
<style lang="scss">
.post {
  .posting-body {
    text-align: justify;

    :first-child {
      font-weight: 600;
    }
  }
  .embedded {
    text-align: center;
    .instagram-media {
      margin: 15px auto !important;
    }
  }
}
</style>
